export const TICKET_SHOW_RESET = 'TICKET_SHOW_RESET'
export const TICKET_SHOW_SET_ERROR = 'TICKET_SHOW_SET_ERROR'
export const TICKET_SHOW_SET_RETRIEVED = 'TICKET_SHOW_SET_RETRIEVED'
export const TICKET_SHOW_TOGGLE_LOADING = 'TICKET_SHOW_TOGGLE_LOADING'
